<div class="d-flex flex-column justify-content-start align-items-stretch h-100 w-100 my-3">

    <app-spinner [isLoading]="isLoadingData" [isFullScreen]="false"></app-spinner>

    <div *ngIf="!isLoadingData" class="container-fluid p-4">

        <p-message
            styleClass="w-100"
            *ngIf="loadingMessage.show"
            [severity]="loadingMessage.severity"
            [text]="loadingMessage.text">
        </p-message>

        <div *ngIf="approbations">

            <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-4">
                <span class="text-primary-color fw-bolder mb-2">{{labels.approbationsLabel}}</span>
                <app-approbations-edition
                    [approbations]="approbations"
                    [(selectedApprobations)]="enrollment.approbations"
                    (approbationsChange)="onApprobationsChange()">
                </app-approbations-edition>

            </div>

        </div>

    </div>

</div>
